import type { SignalNavigationGroup } from "../../enums/navigation";
import { SIGNAL_NAVIGATION_GROUP } from "../../enums/navigation";
import type { SignalModule } from "../../enums/scan";
import { SIGNAL_MODULE, SIGNAL_MODULES } from "../../enums/scan";

type SignalDestination = {
  label: string;
  path: string;
  group: SignalNavigationGroup;
  primaryModule: SignalModule | null;
  badge: string | null;
};

export const SIGNAL_DESTINATIONS = {
  [SIGNAL_MODULE.OVERVIEW]: {
    label: "Workspace home",
    path: "overview",
    group: SIGNAL_NAVIGATION_GROUP.HOME,
    primaryModule: null,
    badge: null,
  },
  [SIGNAL_MODULE.SCAN]: {
    label: "Scan",
    path: "scan",
    group: SIGNAL_NAVIGATION_GROUP.PRIMARY,
    primaryModule: SIGNAL_MODULE.SCAN,
    badge: null,
  },
  [SIGNAL_MODULE.MAP]: {
    label: "Map",
    path: "map",
    group: SIGNAL_NAVIGATION_GROUP.PRIMARY,
    primaryModule: SIGNAL_MODULE.MAP,
    badge: null,
  },
  [SIGNAL_MODULE.BRIEF]: {
    label: "Brief",
    path: "brief",
    group: SIGNAL_NAVIGATION_GROUP.PRIMARY,
    primaryModule: SIGNAL_MODULE.BRIEF,
    badge: null,
  },
  [SIGNAL_MODULE.GOVERN]: {
    label: "Govern",
    path: "govern",
    group: SIGNAL_NAVIGATION_GROUP.PRIMARY,
    primaryModule: SIGNAL_MODULE.GOVERN,
    badge: null,
  },
  [SIGNAL_MODULE.RUNS]: {
    label: "Run history",
    path: "runs",
    group: SIGNAL_NAVIGATION_GROUP.SCAN_HISTORY,
    primaryModule: SIGNAL_MODULE.SCAN,
    badge: null,
  },
  [SIGNAL_MODULE.SOCIAL]: {
    label: "Social",
    path: "social",
    group: SIGNAL_NAVIGATION_GROUP.PRIMARY,
    primaryModule: SIGNAL_MODULE.SOCIAL,
    badge: null,
  },
  [SIGNAL_MODULE.SETTINGS]: {
    label: "Settings",
    path: "settings",
    group: SIGNAL_NAVIGATION_GROUP.UTILITIES,
    primaryModule: null,
    badge: null,
  },
} satisfies Record<SignalModule, SignalDestination>;

export function signalNavigationModules(
  group: SignalNavigationGroup,
  social = false,
): SignalModule[] {
  return SIGNAL_MODULES.filter(
    (module) =>
      SIGNAL_DESTINATIONS[module].group === group &&
      (module !== SIGNAL_MODULE.SOCIAL || social),
  );
}

export function signalDestinationHref(
  websiteId: string,
  module: SignalModule,
): string {
  return `/w/${websiteId}/${SIGNAL_DESTINATIONS[module].path}`;
}

export function primarySignalModule(
  module: SignalModule | "none",
): SignalModule | null {
  return module === "none" ? null : SIGNAL_DESTINATIONS[module].primaryModule;
}
